import queryString from 'query-string';
import config from 'appconfig';

export default () => {
  const loginParams = queryString.stringify({ continue: window.location.href });
  const loginUrl = `${config.idLoginUrl}?${loginParams}`;

  window.location.assign(loginUrl);
};
